import { motion } from 'framer-motion';
import styled, { css, keyframes } from 'styled-components';

const ANIMATION_DURATION = 5;
const ANIMATION_DURATION_RESPONSIVE = 3;
export const PULSE_SIZE = 120;

export const PulseWrapper = styled(motion.div)<{ $responsive?: boolean }>`
    position: absolute;
    height: ${({ $responsive }) => ($responsive ? '100%' : `${PULSE_SIZE}px`)};
    width: ${({ $responsive }) => ($responsive ? '100%' : `${PULSE_SIZE}px`)};
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
`;

const PULSE = keyframes`
    0% {
        transform: scale(0);
        opacity: 0;
    }
    50%  {
        opacity: .8;
    }
    100% {
        transform: scale(1);
        opacity: 0;
    }
`;

const PULSE_RESPONSIVE = keyframes`
    0% {
        transform: scale(1);
        opacity: 0;
    }
    50%  {
        opacity: .5;
    }
    100% {
        transform: scale(2);
        opacity: 0;
    }
`;

interface Props {
    $total: number;
    $index: number;
    $responsive?: boolean;
}

export const Ring = styled.div<Props>`
    position: absolute;
    width: 100%;
    height: 100%;
    border: 2px solid ${({ theme }) => theme.colors.purple};
    border-radius: 100%;
    opacity: 0;
    will-change: transform, opacity;
    transform: ${({ $responsive }) => ($responsive ? 'scale(1)' : `scale(0)`)};

    ${({ $index, $total, $responsive }) =>
        $responsive
            ? css`
                  animation: ${PULSE_RESPONSIVE} ${ANIMATION_DURATION_RESPONSIVE}s
                      ${(ANIMATION_DURATION_RESPONSIVE / $total) * $index}s infinite;
              `
            : css`
                  animation: ${PULSE} ${ANIMATION_DURATION}s ${(ANIMATION_DURATION / $total) * $index}s infinite;
              `}
`;
